// extracted by mini-css-extract-plugin
export default {"wrapper":"gLRXWChsafNJ51NmnRfw","selectorBlocks":"mgVroIb7do3XuDK_OYcw","selectorBlock":"i99xjpLUtA74dYBbUR1a","preview":"OgpjyFQAhWuuYJAoLL1S"};